import React, { useState } from "react";
import FormWrapper from "../../components/Timesheet/FormWrapper";
import TimeSheetDate from "../../components/Timesheet/TimeSheetDate";
import history from "../../routes/history";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { configTimeSheetInit } from "../../redux/actions";

const TimeSheetEndDate = () => {
  const { EndDate = moment(),StartDate=moment() } = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const getPreviousSetValue = () => {
    const date = EndDate ? moment(EndDate, "YYYY-MM-DD") : null;
    return date && date.isSameOrAfter(moment(StartDate).startOf("day"))
      ? date
      : moment().startOf("day");
  };
  const [selectedDate, setSelectedDate] = useState(getPreviousSetValue());
  const dispatch = useDispatch();
  const handleNext = () => {
    dispatch(configTimeSheetInit({ EndDate: selectedDate }));
    history.push("/working-hours");
  };

  return (
    <FormWrapper
      pageTitle={"Configure Timesheet"}
      percent={40}
      nextFunction={() => handleNext()}
      backFunction={() => history.goBack()}
    >
      <TimeSheetDate
        label="End Date"
        selectedDate={moment(selectedDate)}
        handleDateChange={(date) => {
          setSelectedDate(date.format("YYYY-MM-DD"));
        }}
        handleDisableDate={ (date) =>
              date &&
              date.isBefore(moment(StartDate).startOf("day"))}
        showError={false}
      />
    </FormWrapper>
  );
};

export default TimeSheetEndDate;
